<template>
  <div class="hotel-list">
    <div class="title">选择酒店</div>
    <ul class="hotel-list-box">
      <li class="list-item" v-for="(item, index) in list" :key="index" @click="jump(item)">
        <div class="img-box">
          <img :src="`${showImgUrl}${item.hotelImg}`" alt />
        </div>
        <div class="content-box">
          <p class="name">{{ item.hotelName }}</p>
          <p class="star">{{ item.star }}</p>
          <p class="address">{{ item.hotelAddress }}</p>
        </div>
        <div class="price-box">
          ¥{{ item.hotelPrice }}元
          <span>起</span>
        </div>
        <div class="buy">
          去预定
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  name: "hotelList",
  data() {
    return {
      list: [
        {
          name: '南京国际青年会议酒店',
          star: '★★★★',
          address: '南京市南京路121号',
          price: '300',
          hotelImg:require('./static/hotel.jpg')
        },
        {
          name: '双子大酒店',
          star: '★★★',
          address: '北京市朝阳区建国路126号艾维克大厦',
          price: '200',
           hotelImg:require('./static/hotel.jpg')
        },
        {
          name: '南京国际青年会议酒店',
          star: '★★★',
          address: '北京市朝阳区建国路126号艾维克大厦',
          price: '280',
           hotelImg:require('./static/hotel.jpg')
        }
      ],
      showImgUrl: process.env.VUE_APP_SHOW_IMGURL
    }
  },
  computed: {
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    }
  },
  methods: {
    async getHotelList() {
      const res = await http.get(`${apis.getHotelList}/${this.meetingId}`)
      console.log(res)
      this.list = res.HotelList.map((ele) => {
        const obj = ele
        const len = ele.star || 5
        obj.star = ''

        for (var i = 0; i < len; i++) {
          obj.star += '★'
        }
        return obj

      })
    },
    jump(item) {
      this.$store.commit('SET_CURRENT_HOTEL', item)
      this.$router.push('/hotel')
    }
  },
  created() {
    this.getHotelList()
  }
}
</script>

<style lang="stylus" scoped>
.hotel-list {
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 100px;
    .title {
      background-color #fff
      padding 20px 0 20px
      margin 0 30px
      color: #313131
      font-size 20px
      font-weight 700
      border-bottom: 1px solid #C7C7C7;

    }
}
.hotel-list-box {
  background-color: #fff;

  .list-item {
    position relative
    padding: 20px;
    display: flex;
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;

    .img-box {
      width: 164px;
      height: 164px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .content-box {
      margin-left: 10px;
      flex: 1;

      .name {
        font-size: 33px;
      }

      .star {
        font-size: 25px;
        color: #ff4e00;
      }

      .address {
        font-size: 25px;
        color: #737373;
      }
    }

    .price-box {
      /* margin: aotu */
      line-height: 164px;
      width: 146px;
      margin-left: 10px;
      color: #ff4e00;
      font-size: 33px;
      text-align: right;

      span {
        font-size: 25px;
        color: #737373;
      }
    }
    .buy{
        display none
      }
  }
}

@media screen and (min-width: 800px) {
  .hotel-list {
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 100px;

    .title {
      background-color #fff
      padding 20px 0 20px
      margin 0 30px
      color: #313131
      font-size 20px
      font-weight 700
      border-bottom: 1px solid #C7C7C7;

    }
  }

  .hotel-list-box {
    background-color: #fff;
    .list-item {
      position relative
      padding 30px 0 20px
      margin 0 30px
      display: flex;
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;

      .img-box {
        width: 100px;
        height: 100px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .content-box {
        margin-left: 10px;
        flex: 1;
        .name {
          font-size: 20px;
        }

        .star {
          font-size: 20px;
          color: #ff4e00;
        }

        .address {
          font-size: 17px;
          color: #737373;
          width 220px
        }
      }

      .price-box {
        /* margin: aotu */
        line-height: 35px;
        height 35px
        width: 108px;
        // margin-left: 10px;
        color: #ff4e00;
        font-size: 20px;
        // padding-left 50px!important;
        text-align: left ;

        span {
          font-size: 20px;
          color: #737373;
        }
      }
      .buy{
        display block
        position absolute
        top 66px
        right 8px
        width 100px
        height 30px
        line-height 30px
        text-align center
        color #ffffff
        font-size 15px
        background-color #2852A6
      }
    }
  }
}
</style>
